import LightWeightOrder from "../../Components/LightWeightCustomer/LightWeightOrder";

export default function LightWeightOrders(){
    return(
        <LightWeightOrder/>
    )
}